/* STARKFELD Plausible projection. Pure mapping; no transport, storage or identity. */
(function (root) {
  'use strict';
  var SITE = 'https://starkfeld.com';
  var KNOWN_ENCODED_PRODUCT_PATH = '/products/starkfeld%C2%AE-starkgun%C2%AE-mini-kompakte-massagepistole-fur-tiefengewebe';
  var PEAK_HANDLES = ['epic-refuel', 'magnesium-bisglycinat', 'magnesium-citrat', 'daily-protein', 'creatin-creapure', 'hbn-elektrolyt-ph-complex', 'epic-intra', 'clear-whey-isolate', 'clear-protein'];
  function publicUrl(raw) {
    var u;
    try { u = new URL(raw, SITE); } catch (_) { return null; }
    if (!/^https:$/.test(u.protocol) || !/^(www\.)?starkfeld\.com$/.test(u.hostname)) return null;
    if (u.searchParams.has('preview_theme_id') || u.searchParams.has('_fd') || u.searchParams.has('view')) return null;
    var path = u.pathname.replace(/\/{2,}/g, '/');
    if (path === '/checkout/complete') return SITE + path;
    if (/^\/(?:checkouts|checkout)(?:\/|$)/.test(path)) return SITE + '/checkout';
    if (/^\/(?:account|orders|apps|challenge|password)(?:\/|$)/.test(path)) return null;
    // Only this verified non-ASCII product handle is allowed; arbitrary encoded paths remain excluded.
    var withoutLocale = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})\//, '/').replace(/\/$/, '');
    if (withoutLocale.toLowerCase() === KNOWN_ENCODED_PRODUCT_PATH.toLowerCase()) return SITE + path;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})\/)?(?:|pages\/[a-z0-9-]+\/?|blogs\/[a-z0-9-]+(?:\/[a-z0-9-]+)?\/?|products\/[a-z0-9-]+\/?|collections\/[a-z0-9-]+(?:\/products\/[a-z0-9-]+)?\/?|cart\/?|search\/?|404\/?)$/.test(path)) return null;
    return SITE + path;
  }
  function referrerOrigin(raw) {
    try { var u = new URL(raw); return /^https?:$/.test(u.protocol) ? u.origin + '/' : ''; } catch (_) { return ''; }
  }
  function productFamily(product) {
    var u = product && publicUrl(product.url || '');
    var slug = u && u.replace(/\/$/, '').split('/').pop();
    if (!slug) return 'other';
    if (/starkboots|recovery-boots/.test(slug)) return 'starkboots';
    if (/starkair/.test(slug)) return 'starkair';
    if (/starkshake/.test(slug)) return 'starkshake';
    if (/peak/.test(slug) || PEAK_HANDLES.includes(slug)) return 'peak';
    return 'other';
  }
  function money(checkout) {
    if (!checkout || !checkout.totalPrice) return null;
    var raw = checkout.totalPrice.amount;
    var amount = (typeof raw === 'number' || (typeof raw === 'string' && /^\d+(?:\.\d{1,2})?$/.test(raw))) ? Number(raw) : NaN;
    var currency = checkout.currencyCode;
    if (!Number.isFinite(amount) || amount < 0 || !/^[A-Z]{3}$/.test(currency || '')) return null;
    return { amount: amount, currency: currency };
  }
  function commerce(event, revenueEnabled) {
    if (!event || !event.context || !event.context.document) return null;
    var doc = event.context.document;
    var url = publicUrl(doc.location && doc.location.href);
    if (!url) return null;
    var out = { name: '', options: { url: url, u: url, props: {} } };
    var data = event.data || {};
    switch (event.name) {
      case 'product_viewed':
        out.name = 'Product Viewed'; out.options.interactive = false;
        out.options.props.product_family = productFamily(data.productVariant && data.productVariant.product);
        break;
      case 'product_added_to_cart':
        out.name = 'Add to Cart';
        out.options.props.product_family = productFamily(data.cartLine && data.cartLine.merchandise && data.cartLine.merchandise.product);
        break;
      case 'checkout_started':
        out.name = 'Checkout Started'; out.options.url = out.options.u = SITE + '/checkout';
        break;
      case 'checkout_completed':
        out.name = 'Purchase'; out.options.url = out.options.u = SITE + '/checkout/complete';
        var revenue = money(data.checkout);
        if (revenueEnabled && revenue) out.options.revenue = revenue;
        break;
      default: return null;
    }
    return out;
  }
  function tool(channel, detail) {
    var name = detail && (detail.name || detail.event);
    var map = {
      'sf:rx': { rx_start: ['Tool Started', 'set-finder'], rx_result: ['Tool Completed', 'set-finder'] },
      'sf:rc': { rc_start: ['Tool Started', 'recovery-check'], rc_result: ['Tool Completed', 'recovery-check'] },
      'sf:bk': { bk_start: ['Tool Started', 'application-check'], bk_result: ['Tool Completed', 'application-check'] }
    };
    var selected = map[channel] && map[channel][name];
    if (channel === 'sf:protein-result') selected = ['Tool Completed', 'protein-calculator'];
    return selected ? { name: selected[0], props: { tool: selected[1] } } : null;
  }
  var model = Object.freeze({ site: SITE, publicUrl: publicUrl, referrerOrigin: referrerOrigin, commerce: commerce, tool: tool });
  if (typeof module === 'object' && module.exports) module.exports = model;
  else root.SfPlausibleModel = model;
})(typeof window !== 'undefined' ? window : globalThis);
